module.exports = __webpack_public_path__ + "static/media/ex-pricing.b4411275.jpg";